import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { createAccordion } from './Accordion';
import { ACCORDION_BASE_CLASSNAME } from './Constants';
createComponents(".".concat(ACCORDION_BASE_CLASSNAME), createAccordion, NO_PATTERN_BUSINESS_LOGIC);
